import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';

import { DynamicFormComponent } from '@shared/dynamic-form/dynamic-form.component';

import { SortService } from '@services/sort.service';

import { inOutFade } from '@json/src/app/animations/general';
import { Utils } from '@json/src/app/Utils';
import { Permission, PermissionType } from '@json/src/app/enums/PermissionType';
import moment from 'moment';

@Component({
  selector: 'app-patient-edit-incidents',
  templateUrl: './incidents.component.html',
  styleUrls: ['../diagnosis/diagnosis.component.scss'],
  animations: [ inOutFade ]
})
export class IncidentsComponent extends DynamicFormComponent implements OnInit, OnDestroy {

  @ViewChild('incidentsCourse') incidentsCourse: ElementRef;
  Utils = Utils;
  Permission = Permission;
  PermissionType = PermissionType;

  constructor(
    protected override sortService: SortService,
    protected override cdr: ChangeDetectorRef
  ) {
    super(sortService, cdr)
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.schema.forEach(schema => schema.childs?.forEach(child => {this.fieldVisible(child, child)}));
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  addNewItem($event: any, section: any) {
    $event.stopPropagation();

    let element: ElementRef;

    switch( section.childs[0].customType ) {
      case 'clinic-course': element = this.incidentsCourse; break;
    }

    // @ts-ignore
    element?.addOne();

    // @ts-ignore
    const formArray = element?.formArray;
    if (formArray?.length) {
      const newForm = formArray.at(0);
      newForm.patchValue({ date: moment() });
    }
  }

  openCalendar($event: any, section: any) {
    $event.stopPropagation();

    let element: ElementRef;

    switch( section.childs[0].customType ) {
      case 'clinic-course': element = this.incidentsCourse; break;
    }

    // @ts-ignore
    element.showCalendar = !element.showCalendar;
  }
}
